<template>
    <div class="knowledgebase">
        <div class="main-wrapper">
            <layout-header></layout-header>
            <layout-sidebar></layout-sidebar>
            <!-- Page Wrapper -->
            <div class="page-wrapper">

                <!-- Page Content -->
                <div class="content container-fluid">

                    <!-- Page Header -->
                    <div class="page-header">
                        <div class="row">
                            <div class="col-sm-12">
                                <h3 class="page-title">Knowledgebase</h3>
                                <ul class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/index">Dashboard</router-link>
                                    </li>
                                    <li class="breadcrumb-item active">Knowledgebase</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!-- /Page Header -->

                    <div class="row">
                        <div class="col-xl-4 col-md-6 col-sm-6">
                            <div class="topics">
                                <h3 class="topic-title"><a href="#"><i class="fa fa-folder-o"></i> Installation &
                                        Activation <span>11</span></a></h3>
                                <ul class="topics-list">
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-6">
                            <div class="topics">
                                <h3 class="topic-title"><a href="#"><i class="fa fa-folder-o"></i> Premium Members
                                        Features <span>11</span></a></h3>
                                <ul class="topics-list">
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-6">
                            <div class="topics">
                                <h3 class="topic-title"><a href="#"><i class="fa fa-folder-o"></i> API Usage & Guide
                                        lines <span>11</span></a></h3>
                                <ul class="topics-list">
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-6">
                            <div class="topics">
                                <h3 class="topic-title"><a href="#"><i class="fa fa-folder-o"></i> Getting Started
                                        <span>11</span></a></h3>
                                <ul class="topics-list">
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-6">
                            <div class="topics">
                                <h3 class="topic-title"><a href="#"><i class="fa fa-folder-o"></i> Lorem ipsum dolor
                                        <span>11</span></a></h3>
                                <ul class="topics-list">
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-6">
                            <div class="topics">
                                <h3 class="topic-title"><a href="#"><i class="fa fa-folder-o"></i> Lorem ipsum dolor
                                        <span>11</span></a></h3>
                                <ul class="topics-list">
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-6">
                            <div class="topics">
                                <h3 class="topic-title"><a href="#"><i class="fa fa-folder-o"></i> Lorem ipsum dolor
                                        <span>11</span></a></h3>
                                <ul class="topics-list">
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-6">
                            <div class="topics">
                                <h3 class="topic-title"><a href="#"><i class="fa fa-folder-o"></i> Lorem ipsum dolor
                                        <span>11</span></a></h3>
                                <ul class="topics-list">
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-6 ">
                            <div class="topics">
                                <h3 class="topic-title"><a href="#"><i class="fa fa-folder-o"></i> Lorem ipsum dolor
                                        <span>11</span></a></h3>
                                <ul class="topics-list">
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/knowledgebaseview"> Sed ut perspiciatis unde omnis?
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- /Page Content -->

            </div>
            <!-- /Page Wrapper -->
        </div>
    </div>
</template>

<script>
    import LayoutHeader from '@/components/layouts/Header.vue'
    import LayoutSidebar from '@/components/layouts/Sidebar.vue'
    export default {
        components: {
            LayoutHeader,
            LayoutSidebar,
        },
        mounted() {
            if ($('.floating').length > 0) {
                $('.floating').on('focus blur', function (e) {
                    $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
                }).trigger('blur');
            }
        },
        name: 'knowledgebase'
    }
</script>


// WEBPACK FOOTER //
// src/components/knowledgebase.vue